/* eslint-disable max-depth */

import Block from 'Mixins/Block';

export default Block('component-search-result', {
	fn: {

	},
	onLoad (block) {

		// String max length
		const preambleList = block.child('.component-search-result__list-preamble');
		const stringLimit = 240;
		for (let i = 0; i < preambleList.length; i++) {
			const pEl = preambleList[i].querySelectorAll('p');
			for (let i = 0; i < pEl.length; i++) {
				let element = pEl[i];
				let newElement;
				if(i === 0){
					if(element.innerHTML.length > stringLimit){
						newElement = element.innerHTML.slice(0, -(element.innerHTML.length-stringLimit));
						element.innerHTML = `${newElement}...`;
					}
				} else {
					element.classList.add('component-search-result__list-preamble--hide');
				}
			}
		}
	}
});